// Merkt sich, welche Stories der User schon geöffnet hat - im localStorage, bleibt über
// Seiten-Neuladen erhalten. Gleiches Muster wie useFavoriten.js: State auf Modul-Ebene (geteilt
// über alle Aufrufer), nicht innerhalb der Funktion, sonst hätte jede Widget-Instanz ihren
// eigenen, unabhängigen Stand.
import { ref, watch } from 'vue'

const SPEICHER_SCHLUESSEL = 'tm-spielplan-gesehene-stories'

function ladeGeseheneStories() {
  try {
    const roh = localStorage.getItem(SPEICHER_SCHLUESSEL)
    return roh ? new Set(JSON.parse(roh)) : new Set()
  } catch {
    return new Set()
  }
}

const geseheneStories = ref(ladeGeseheneStories())

watch(geseheneStories, (neu) => {
  try {
    localStorage.setItem(SPEICHER_SCHLUESSEL, JSON.stringify([...neu]))
  } catch {
    // ignorieren, falls Speichern fehlschlägt (z.B. Safari privater Modus)
  }
}, { deep: true })

export function useGeseheneStories() {
  function istGesehen(matchId) {
    return matchId != null && geseheneStories.value.has(matchId)
  }

  function markiereAlsGesehen(matchId) {
    if (matchId == null) return
    geseheneStories.value.add(matchId)
  }

  return { istGesehen, markiereAlsGesehen }
}